<template functional>
  <v-btn
    class="px-3 py-2 btn"
    outline
    round
    :class="[data.class, data.staticClass, props.blue ? 'blue' : '']"
    :style="[data.style, data.staticStyle]"
    v-bind="[data.attrs]"
    v-on="listeners"
  >
    <slot />
  </v-btn>
</template>

<script>
export default {
  props: {
    blue: {
      type: Boolean,
      default: () => false
    }
  }
}
</script>

<style lang="scss" scoped>
.btn {
  margin: 0;
  transition: background-color 0.15s, border-color 0.15s;
  transition-timing-function: ease-in-out;
  color: #222 !important;
  border: 1px solid #adadad !important;
  background-color: var(--metal-white) !important;

  &:hover, &:focus {
    color: var(--metal-white) !important;
    background-color: var(--metal-brown) !important;
    border-color: var(--metal-brown) !important;
  }
}

.blue {
  color: var(--metal-blue) !important;
  border: 3px solid var(--metal-blue) !important;
  background-color: transparent !important;

  &:hover, &:focus {
    color: var(--metal-white) !important;
    background-color: var(--metal-blue) !important;
    border-color: var(--metal-blue) !important;
  }
}
</style>
